export function isEligible(buzz, isDesktop) {
  return !(
    !buzz.isShopping ||
    isDesktop ||
    buzz.isAd ||
    !['US', 'UK'].includes(buzz.classification.edition) ||
    !buzz.isEnglish
  );
}
